import React, { FunctionComponent, useMemo } from 'react';

import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme/ScopedTheme';
import { ConferenceStatus } from '@yandex-360/telemost-sdk';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { selectConferenceBackground } from '../../../../../shared/features/config/selectors';
import { selectIsSlotPluginsEnabled } from '../../../../../shared/features/flags/selectors';
import { useTypedSelector } from '../../../../../shared/hooks/useTypedSelector';
import { ParticipantsSidebar } from '../../../components/participants-sidebar';
import { getConferenceStatus, getSidebarContent } from '../../../selectors';
import { SidebarContent } from '../../../types';
import { ChatWidget } from '../../chat';
import { PluginsSidebar } from '../../slot-plugins/components/plugins-sidebar';
import styles from './styles.css';

interface SidebarProps {
    withChat?: boolean;
}

const Sidebar: FunctionComponent<SidebarProps> = ({ withChat }) => {
    const sidebarContent = useSelector(getSidebarContent);
    const isJoined = useTypedSelector((state) => getConferenceStatus(state) === ConferenceStatus.JOINED);
    const isSlotPluginsEnabled = useSelector(selectIsSlotPluginsEnabled);
    const shouldShowPlugins = sidebarContent === SidebarContent.Plugins && isSlotPluginsEnabled;
    const isVisible = useMemo(
        () => sidebarContent !== null && isJoined && (sidebarContent !== SidebarContent.Plugins || shouldShowPlugins),
        [isJoined, shouldShowPlugins, sidebarContent]
    );
    const isOverlay = shouldShowPlugins;

    const conferenceBackground = useSelector(selectConferenceBackground);

    return (
        <ScopedTheme theme="dark">
            <div
                className={cn(styles.sidebar, { [styles.visible]: isVisible, [styles.overlay]: isOverlay })}
                style={conferenceBackground ? { backgroundColor: conferenceBackground } : {}}
            >
                {withChat ? <ChatWidget visible={sidebarContent === SidebarContent.Chat} /> : null}
                {sidebarContent === SidebarContent.Participants ? <ParticipantsSidebar /> : null}
                {shouldShowPlugins ? <PluginsSidebar /> : null}
            </div>
        </ScopedTheme>
    );
};

export { Sidebar };
